/* tslint:disable:max-line-length */
import { Messages } from '../messages.interfaces';

// [en] English - Inglés
export const en: Messages = {
  close: {
    buttonText: 'Close',
    description: 'Close search'
  },
  columnsPicker: {
    name: 'Columns Picker',
    title: 'View'
  },
  discoveryWall: {
    clicks: 'Your last searches',
    queries: 'New products related to your queries',
    section: 'Popular searches in {section}',
    user: 'Specially for you'
  },
  facets: {
    clearFilters: 'Clear filters',
    defaultDynamicRange: {
      clear: '×',
      filter: '→'
    },
    defaultRange: { lessHTML: '< {max}', betweenHTML: '{min} - {max}', fromHTML: '> {min}' },
    itemCounter: '{value} results',
    searchBoxPlaceholder: 'Search {title}',
    showLess: 'Show less',
    showMore: 'Show more',
    titles: {
      rootCategories: 'Categories',
      hierarchical_category: 'Categories',
      color_facet: 'Color',
      size_facet: 'Size'
    },
    toggle: {
      default: {
        closeHTML: 'Apply filters',
        openHTML: 'Filter'
      },
      groups: {}
    },
    values: {}
  },
  fallbackFilters: {
    messageHTML: `<span class="ebx-fallback-facet__message-apologies">We are sorry! We couldn't find any result for
<strong class="ebx-fallback-facet__message-query">{query}</strong> en </span>
<strong class="ebx-fallback-facet__message-filter">{filter}</strong>
<span class="ebx-fallback-facet__message-try-again">, but we've found these others filters combinations with results:</span>`
  },
  history: {
    title: 'Recent searches',
    enable: 'Enable',
    disable: 'Disable',
    clear: 'Clear all',
    clearItem: 'Clear history item {term}'
  },
  identifierSuggestions: {
    title: ''
  },
  nextQueriesSuggestions: {
    title: 'You may be interested'
  },
  nextQueries: {
    titleHTML: '',
    nextQuery: {
      titleHTML: 'Other customers have also searched: <span class="ebx-next-query__title-query">{query}</span> <span class="ebx-next-query__title-count">({numFound})</span>',
      viewAllHTML: 'View all <span class="ebx-next-query__view-all-count">({numFound})</span>'
    }
  },
  noResults: {
    messageHTML: `<span class="ebx-no-results__message-apologies">We are sorry! We couldn't find any results for:</span> <span class="ebx-no-results__message-query">{query}</span><span class="ebx-no-results__message-try-again">. Please try again with other words.</span>`
  },
  emptySearch: {
    message: ''
  },
  partialResult: {
    titleHTML: '<span class="ebx-partial-result__title-term">{term}</span> <span class="ebx-partial-result__title-num-found">({numFound})</span>',
    messageHTML: `<span class="ebx-partials__message-apologies">We are sorry! We couldn't find any results for:</span> <span class="ebx-partials__message-query">{query}</span><span class="ebx-partials__message-try-again">, but we've found these results: </span>`,
    viewAllHTML: 'View all <span class="ebx-partial-result__view-all-count">({numFound})</span>'
  },
  promotedLabel: '',
  resultsFoundHTML: '<span class="ebx-results-number__count">{resultsNumber}</span> results',
  search: {
    clear: 'Clear search',
    name: 'Search box',
    suggestion: '{suggestion} search suggestion',
    inputPlaceholderAlternativesHTML: ['Search']
  },
  popularSearches: {
    title: 'Popular Searches',
    inCategory: 'in'
  },
  rating: {
    ariaLabel: 'Rated {value} out of {max}',
    label: '{value}'
  },
  recommendations: {
    title: 'Maybe you might be interested',
    showAll: 'Show all'
  },
  redirectionsSuggestions: {
    title: 'Direct Links'
  },
  results: {
    addToCart: 'Add to cart',
    identifierTitle: '',
    addToWishlist: 'Add to wishlist',
    removeFromWishlist: 'Remove from wishlist'
  },
  resultsSuggestions: {
    title: 'Most searched products'
  },
  sections: {},
  selectedFilters: {
    title: 'Filtros seleccionados ({count})'
  },
  slidingPanel: {
    scrollLeft: 'Scroll left',
    scrollRight: 'Scroll right'
  },
  sort: {
    titleHTML: 'Order by {selectedItem}',
    sortTitles: {
      default: 'Relevance',
      priceAsc: 'Price asc',
      priceDesc: 'Price desc'
    }
  },
  spellcheck: 'No results were found for \'{query}\'. Here are the results for \'{spellcheck}\'',
  suggestions: {
    title: 'Top trends',
    inCategory: 'in'
  },
  scrollToTop: {
    name: 'Scroll to top'
  }
};
